var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./base.service";
export class PromotionService extends BaseService {
    constructor(ellCommerce) {
        super(ellCommerce, "promotion");
    }
    getCoupons() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `coupons`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCouponsByCountry(countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `coupons/country/${iso2}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCouponById(couponId, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `coupons/${couponId}/country/${iso2}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCouponByCode(couponCode, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `coupons/code/${couponCode}/country/${iso2}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    createCouponByCountry(coupon, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `coupons/country/${iso2}`,
                    method: "POST",
                    data: coupon,
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    createCoupon(coupon) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `coupons`,
                    method: "POST",
                    data: coupon,
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    deleteCoupon(couponId, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `coupons/${couponId}/country/${iso2}`,
                    method: "DELETE",
                });
                return (response === null || response === void 0 ? void 0 : response.status) === 200;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
}
